module.exports = __webpack_public_path__ + "static/media/history.b3620e7e.png";